import PropTypes from 'prop-types';
import { ReactComponent as IconStar } from "assets/images/icons/star.svg";
import { ReactComponent as IconStarOutline } from "assets/images/icons/icon-star-outline.svg";
import Button from "components/ui/Button/Button";
import useData from "hooks/useData";
import { useEffect, useState } from "react";

const ButtonFavorite = ({ profileId }) => {
  const { getData, postData, deleteData } = useData();
  const [isLoading, setIsLoading] = useState();
  const [isFavorite, setIsFavorite] = useState();

  useEffect(
    () => {
      const load = async () => {
        setIsLoading(true);
        const { data } = await getData(`rest/profile/${ profileId }/favorite`);
        setIsFavorite(data?.id);
        setIsLoading(false);
      }
      if (!isLoading) {
        load();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const addFavorite = async () => {
    const result = await postData(`rest/profile/${ profileId }/favorite`);
    if (result.status === 200) {
      setIsFavorite(true);
    }
  }

  const removeFavorite = async () => {
    const result = await deleteData(`rest/profile/${ profileId }/favorite`);
    if (result.status === 200) {
      setIsFavorite(false);
    }
  }

  if (isLoading) {
    return null;
  }

  return (
    <Button variant={ 'secondary' }
            onClick={ () => isFavorite ? removeFavorite() : addFavorite() }
            className={ isFavorite ? '' : 'button--no-fill' }>

      { isFavorite ? <IconStar/> : <IconStarOutline/>  }
      { isFavorite ? 'Favoriet verwijderen' : 'Favoriet toevoegen' }
    </Button>
  )
}

ButtonFavorite.propTypes = {
  profileId: PropTypes.number.isRequired,
}

export default ButtonFavorite;
